module.exports = __webpack_public_path__ + "static/img/logo-kidstthink.7fb2ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-kidstthink.svg
// module id = u/Iu
// module chunks = 1